// GENERATED by the workspace box from this app’s own contract — never edit it, every sync rewrites it.
// WHO MAY STAND IN THIS APP, and the only per-model fact the platform’s own `src/main.tsx` reads.
//
// `roles` is the same list the SERVER bakes into `src/auth/roles.ts` as `APP_ROLES` — one authority
// (`appRoles`), never a second derivation — so a gate keyed on it can never name a role the API does
// not enforce. `hasServedRole` says whether this design declared anybody who may act with no grant at
// all: when it is false, every role here is the owner’s to give and a fresh sign-up holds nothing.
//
// `undefined` means this model has no auth. It is an ABSENT fact rather than a false one, because the
// server emits no `roles.ts` for such a model either — and the gate reads the absence as "never ask
// about a session", so an app with no accounts gains no `get-session` probe it never had.

export const APP_ACCESS = {
  roles: [],
  hasServedRole: true,
} as const;
